"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var styles_1 = require("@material-ui/core/styles");
var core_1 = require("@material-ui/core");
var Button_1 = __importDefault(require("../../Button"));
var TextField_1 = __importDefault(require("../../TextField"));
exports.useStyles = styles_1.makeStyles(function () { return ({
    root: {},
}); });
var SelectEditOptionDialog = function (_a) {
    var classNameProp = _a.className, error = _a.error, onClose = _a.onClose, onClickDelete = _a.onClickDelete, onSubmit = _a.onSubmit, onChange = _a.onChange, value = _a.value, other = __rest(_a, ["className", "error", "onClose", "onClickDelete", "onSubmit", "onChange", "value"]);
    var classes = exports.useStyles();
    return (react_1.default.createElement(core_1.Dialog, __assign({ className: clsx_1.default(classes.root, classNameProp), onClose: onClose }, other),
        react_1.default.createElement(core_1.DialogContent, null,
            react_1.default.createElement(TextField_1.default, { label: "Name", name: "name", id: "edit-select-option-name-field", variant: "bordered", error: !!error, helperText: error, value: value, onChange: onChange })),
        react_1.default.createElement(core_1.DialogActions, null,
            react_1.default.createElement(Button_1.default, { variant: "text", size: "small", onClick: onClose }, "Cancel"),
            react_1.default.createElement(Button_1.default, { variant: "text", color: "danger", size: "small", onClick: onClickDelete }, "Delete"),
            react_1.default.createElement(Button_1.default, { type: "submit", variant: "text", size: "small", color: "primary", onClick: onSubmit }, "Save"))));
};
exports.default = SelectEditOptionDialog;
//# sourceMappingURL=SelectEditOptionDialog.js.map